var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "layer_section layer-area type-wide-a",
      attrs: { id: "orderHistory" }
    },
    [
      _c("div", { staticClass: "layer_section-container" }, [
        _c("div", { staticClass: "layer-content order-history" }, [
          _c("h2", { staticClass: "order-history__header" }, [
            _vm._v(
              "\n              " +
                _vm._s(_vm.orderinfo.name) +
                " 님의 주문내역\n          "
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "order-history__result" }, [
            _vm._v("\n              총 "),
            _c("strong", { staticClass: "count" }, [
              _vm._v(_vm._s(_vm.orderlist.length) + "개")
            ]),
            _vm._v("의 주문내역이 있습니다.\n          ")
          ]),
          _vm._v(" "),
          _vm.orderinfo.privacy !== "Y"
            ? _c("div", { staticClass: "order-history__nodata" }, [
                _c("p", [
                  _vm._v(
                    "* 해당 신규 ABO 가입  시 개인정보 제 3자 제공동의를 하지 않으셨기 때문에, 상세 주문 정보는 제공되지 않습니다."
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.orderinfo.privacy === "Y"
            ? _c(
                "div",
                { staticClass: "order-history__list" },
                _vm._l(_vm.orderlist, function(order, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "order-history__list-item" },
                    [
                      _c("div", { staticClass: "order-no" }, [
                        _vm._v("180-" + _vm._s(order.number))
                      ]),
                      _vm._v(" "),
                      _c("dl", { staticClass: "list" }, [
                        _c("div", { staticClass: "list__row" }, [
                          _c("dt", { staticClass: "list__title" }, [
                            _vm._v("주문날짜")
                          ]),
                          _vm._v(" "),
                          _c("dd", { staticClass: "list__desc" }, [
                            _vm._v(_vm._s(order.date))
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "list__row" }, [
                          _c("dt", { staticClass: "list__title" }, [
                            _vm._v("주문금액")
                          ]),
                          _vm._v(" "),
                          _c("dd", { staticClass: "list__desc" }, [
                            _vm._v(_vm._s(order.amt) + " 원")
                          ])
                        ])
                      ])
                    ]
                  )
                }),
                0
              )
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "align-box size-auto" }, [
          _c(
            "button",
            {
              staticClass: "btn-modal_close",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  return _vm.$emit("layer")
                }
              }
            },
            [_vm._v("확인")]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ceae1e66", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ceae1e66","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/sales/dashboard/component/layerAboOrderHistory.vue
// module id = null
// module chunks = 